export enum StatementType {
  CONSOLIDATED = 'Consolidated',
  ACCOUNT = 'Account',
  CARD = 'Card',
}
